// extracted by mini-css-extract-plugin
export default {"cas":"index_cas__Bc3We","rejectbutton":"index_rejectbutton__7Nzqy"};